import { io, Socket } from 'socket.io-client';

// CONFIG
import ConfigLoader from '@ConfigLoader/ConfigLoader';

//MODULES
import SocketServiceMessageActions from './SocketService.messageActions';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { TJackpotCasinoNotification } from '@GFTypes/index';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

class SocketService {
    private WebSocketClient: Socket;
    private WebSocketJackpot: Socket;
    private baseUrl: string;
    private authToken: string;
    private handShakeBase: string;

    private storeMessage(message: { event: string; balance?: any }) {
        SocketServiceMessageActions.storeMessage(message);
    }

    private clientNotification() {
        const handShake = `${this.handShakeBase}${ConfigLoader.connectionConfiguration.gateways.notifier}`;

        this.WebSocketClient = io(this.baseUrl, {
            transports: ['websocket'],
            path: handShake,
            query: {
                token: this.authToken
            }
        });
        this.WebSocketClient.on('connect', () => {});

        this.WebSocketClient.on('notification', (data: any) => {
            this.storeMessage(data);
        });

        this.WebSocketClient.on('disconnect', (event: any) => {});
        this.WebSocketClient.on('error', (event: any) => {});
    }

    private jackpotNotification() {
        const handShake = `${this.handShakeBase}${ConfigLoader.connectionConfiguration.gateways.jackpotCasinoNotifier}`;
        const urlParams = ConfigLoader.urlParameters;

        this.WebSocketJackpot = io(this.baseUrl, {
            transports: ['websocket'],
            path: handShake,
            query: {
                token: this.authToken,
                gameId: urlParams.gameId,
                casinoId: urlParams.casinoId,
                isDemoPlay: urlParams.isDemoPlay
            }
        });

        this.WebSocketJackpot.on('connect', () => {});

        this.WebSocketJackpot.on('notification', (data: TJackpotCasinoNotification) => {
            EventsCenter.emit(EGameEvents.JACKPOT_CASINO_NOTIFICATION, data);
        });
    }

    init() {
        this.baseUrl = ConfigLoader.connectionConfiguration.baseUrl.replace('/api/', '/');
        this.authToken = ConfigLoader.getAuthToken();
        this.handShakeBase = `/api/${ConfigLoader.connectionConfiguration.apiVersion}`;

        this.clientNotification();
        if (ConfigLoader.getConfiguration(EConfigurationNames.GAME).dynamicCasinoJackpot.available) {
            this.jackpotNotification();
        }
    }

    sendMessage(data: any) {
        this.WebSocketClient.send(JSON.stringify(data));
    }
}

export default new SocketService();
